import { render } from "./Paginacion.vue?vue&type=template&id=53303b04&scoped=true"
import script from "./Paginacion.vue?vue&type=script&lang=js"
export * from "./Paginacion.vue?vue&type=script&lang=js"

import "./Paginacion.vue?vue&type=style&index=0&id=53303b04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53303b04"]])

export default __exports__